// extracted by mini-css-extract-plugin
export default {"thankYouMessage":"xwhZ2T","errorMessage":"PDBHJ0","errorIcon":"ElHTdl"};